import { TextBoxMinusIcon } from './TextBoxMinusIcon';

/**
 * author: Michael Irigoyen
 * id 60E9BECF-1FDF-4077-9BD7-F7B1863C2F66
 * name text-box-minus
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-minus.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxMinusIcon = TextBoxMinusIcon;
export default FileDocumentBoxMinusIcon